<template>
    <div
        id="be-email"
        class="bg-light"
    >
        <div class="body-wrapper">
            <backend-header />
            <main>
                <div class="barra-titolo-azioni bg-white border-bottom py-2">
                    <div class="container-fluid">
                        <div class="row d-flex justify-content-between flex-wrap align-items-center">
                            <div class="col-sm-8">
                                <h1 class="mb-0">{{$t('Email')}}</h1>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="container-fluid mt-5">
                    <div class="controlli-elenco row d-flex justify-content-between align-items-center flex-wrap">
                        <div class="col-md-3">
                            <button
                                type="button"
                                class="btn btn-light border"
                                v-b-modal.popupricerca
                            >
                                {{$t('Ricerca con filtri')}}</button>
                        </div>
                        <div class="row filters-labels col-md-12 mt-2">
                            <b-alert
                                dismissible
                                :show="searchForward.gallery !== ''"
                                @dismissed="clearFilter('gallery')"
                                class="ml-2 mb-0 mt-1 py-0 pl-1"
                            >
                                <small>{{$t('Gallery')}}: {{getGalleryLabel(searchForward.gallery)}}</small>
                            </b-alert>
                            <b-alert
                                dismissible
                                :show="searchForward.email !== ''"
                                @dismissed="clearFilter('email')"
                                class="ml-2 mb-0 mt-1 py-0 pl-1"
                            >
                                <small>{{$t('Email')}}: {{searchForward.email}}</small>
                            </b-alert>
                            <b-alert
                                dismissible
                                :show="!isAgent && searchForward.agent !== ''"
                                @dismissed="clearFilter('agent')"
                                class="ml-2 mb-0 mt-1 py-0 pl-1"
                            >
                                <small>{{$t('Agente')}}: {{getAgentLabel(searchForward.agent)}}</small>
                            </b-alert>
                            <div class="align-middle mt-1">
                                <a
                                    class="ml-2"
                                    href=""
                                    v-if="searchForward.gallery !== '' || searchForward.email !== '' || (!isAgent && searchForward.agent !== '')"
                                    @click.prevent="clearFilter()"
                                >
                                    <small>{{$t('Pulisci tutti i filtri')}}</small>
                                </a>
                            </div>
                        </div>
                    </div>

                    <b-table
                        class="elenco-email tabella-responsive table table-striped mt-3 mb-0"
                        striped
                        id="emails-table"
                        :per-page="pagination.perPage"
                        :current-page="pagination.currentPage"
                        :items="filteredForwards"
                        :fields="tableHead"
                        :tbody-tr-class="'email mt-0'"
                        :sort-by.sync="sortBy"
                        :sort-desc.sync="sortDesc"
                    >
                        <!-- HEAD -->
                        <template #head(eventTitle)="data">
                            <span class="px-1">{{ data.label }}</span>
                        </template>
                        <template #head(sentTo)="data">
                            <span class="px-1">{{ data.label }}</span>
                        </template>
                        <template #head(subject)="data">
                            <span class="px-1">{{ data.label }}</span>
                        </template>
                        <template #head(lastActivity)="data">
                            <span class="px-1">{{ data.label }}</span>
                        </template>

                        <!-- TABLE BODY DATA -->
                        <template #cell(eventTitle)="data">
                            <span class="">{{data.item.eventTitle}}</span>
                        </template>
                        <template #cell(sentTo)="data">
                            <span class="destinatario-email">{{data.item.sentTo}}</span>
                        </template>
                        <template #cell(subject)="data">
                            <span class="oggetto-email">{{data.item.subject}}</span>
                        </template>
                        <template #cell(lastActivity)="data">
                            <span v-if="data.item.lastActivity && data.item.lastActivity.date">
                                <span class="data-email">{{data.item.lastActivity.date | formatDateSlash}}</span>
                                <span class="text-muted"> ({{ data.item.lastActivity.type }})</span>
                            </span>
                            <span v-else>-</span>
                        </template>
                    </b-table>

                    <nav
                        class="paginazione mt-3"
                        aria-label="Paginazione"
                    >
                        <b-pagination
                            v-model="pagination.currentPage"
                            :total-rows="paginationRows"
                            :per-page="pagination.perPage"
                            aria-controls="emails-table"
                            align="right"
                            class="pagination justify-content-end mb-0"
                        />
                    </nav>
                </div>

            </main>
            <backend-footer />
            <!-- popup ricerca gallery -->
            <b-modal
                id="popupricerca"
                :title="$t('Cerca invii')"
                @ok="onPopupRicercaOk"
            >

                <div class="form-group mt-1 mb-2">

                    <label
                        for="gallery"
                        class="mb-0"
                    >{{$t('Gallery')}}</label>

                    <!--b-form-input
                        ref="popupRicercaGallery"
                        list="gallery"
                        autocomplete="off"
                        placeholder="Qualsiasi"
                        :value="searchForward.gallery"
                        class="datalist-select"
                    ></b-form-input>

                    <b-form-datalist
                        name="gallery"
                        id="gallery"
                    >
                        <option value="">{{$t('Qualsiasi')}}</option>
                        <option
                            v-for="gallery in galleries"
                            :key="gallery.id"
                            :value="gallery.title"
                        >{{ gallery.title }}</option>
                    </b-form-datalist-->

                    <b-form-select
                        class="form-control"
                        name="gallery"
                        id="gallery"
                        ref="popupRicercaGallery"
                        :value="searchForward.gallery"
                    >
                        <option value="">{{$t('Qualsiasi')}}</option>
                        <option
                            v-for="gallery in galleries"
                            :key="gallery.id"
                            :value="gallery.id"
                        >
                            {{gallery.title}}
                        </option>
                    </b-form-select>
                </div>
                <div class="form-group mt-1 mb-2">
                    <label
                        for="email"
                        class="mb-0"
                    >{{('Email')}}</label>
                    <input
                        ref="popupRicercaEmail"
                        type="text"
                        class="form-control"
                        name="email"
                        id="email"
                        :value="searchForward.email"
                    >
                </div>
                <div
                    class="form-group mt-1 mb-2"
                    v-if="!isAgent"
                >
                    <label class="mb-0">{{ $t("Collaboratore") }}</label>
                    <b-form-select
                        ref="popupRicercaAgent"
                        class="form-control"
                        :value="searchForward.agent"
                        :options="agents"
                        value-field="fkUtenteAgente"
                        text-field="email"
                        required
                    >
                        <template #first>
                            <b-form-select-option value="">{{$t('Tutti')}}</b-form-select-option>
                        </template>
                    </b-form-select>
                </div>
                <template #modal-footer="{ok,cancel}">
                    <b-button
                        class="btn btn-light border"
                        @click="cancel()"
                    >
                        {{ $t("Annulla") }}
                    </b-button>
                    <b-button
                        class="btn btn-primary btn-rikorda1"
                        @click="ok()"
                    >
                        {{ $t("Cerca") }}
                    </b-button>
                </template>
            </b-modal>
        </div>
    </div>
</template>

<script>
import BackendHeader from "../../../components/backend/Header";
import BackendFooter from "../../../components/backend/Footer";

export default {
    name: "BackendReportsEmail",
    components: { BackendFooter, BackendHeader },
    data() {
        return {
            forwards: [],
            filteredForwards: [],
            galleries: [],
            searchForward: {
                gallery: "",
                email: "",
                agent: ""
            },
            agents: [],
            pagination: {
                perPage: 10,
                currentPage: 1
            },
            sortBy: "lastActivity",
            sortDesc: true,
            tableHead: [
                {
                    key: "eventTitle",
                    label: "Gallery",
                    thClass: "px-1",
                    tdClass: "align-middle px-1",
                    tdAttr: { "data-title": "Gallery" },
                    sortable: true
                },
                {
                    key: "sentTo",
                    label: "Inviata a",
                    thClass: "px-1",
                    tdClass: "align-middle px-1",
                    tdAttr: { "data-title": "Inviata a" },
                    sortable: true
                },
                {
                    key: "subject",
                    label: "Oggetto",
                    thClass: "px-1",
                    tdClass: "align-middle px-1",
                    tdAttr: { "data-title": "Oggetto" },
                    sortable: true
                },
                {
                    key: "lastActivity",
                    label: "Ultima attività",
                    thClass: "px-1",
                    tdClass: "align-middle px-1",
                    tdAttr: { "data-title": "Ultima attività" },
                    sortable: true
                }
            ]
        };
    },
    mounted() {
        this.$api
            .backendGetEmailsReport()
            .then((result) => {
                console.debug("BACKEND_GET_EMAILS_REPORT", result);
                this.forwards = result.forwards;
                this.forwards.forEach((el) => {
                    let dates = [
                        new Date(el.sentDate),
                        new Date(el.openDate),
                        new Date(el.clickDate)
                    ];
                    let lastDate = new Date(Math.max(...dates));
                    let lastIndex = dates.map(Number).indexOf(+lastDate);
                    switch (lastIndex) {
                        case 0:
                            el.lastActivity = {
                                date: el.sentDate,
                                type: "Invio"
                            };
                            break;
                        case 1:
                            el.lastActivity = {
                                date: el.openDate,
                                type: "Apertura"
                            };
                            break;
                        case 2:
                            el.lastActivity = {
                                date: el.clickDate,
                                type: "Click"
                            };
                            break;
                    }
                });
                this.filteredForwards = this.forwards;
                this.galleries = result.eventsList;
                this.agents = result.agents;
                if (this.isAgent && this.forwards.length > 0) {
                    this.searchForward.agent = this.forwards[0].fkUtenteAgente;
                }
            })
            .catch((error) => {
                console.error("BACKEND_GET_EMAILS_REPORT", error);
                this.$router.push({
                    name: this.$route.meta.gotoOnAuthFailed,
                    params: this.$route.params
                });
            });
    },
    methods: {
        onPopupRicercaOk() {
            this.searchForward.gallery = this.$refs.popupRicercaGallery.$el.value;
            this.searchForward.email = this.$refs.popupRicercaEmail.value;
            if (!this.isAgent) {
                this.searchForward.agent = this.$refs.popupRicercaAgent.$el.value;
            }
            this.filterCustom();
        },

        filterCustom() {
            this.filteredForwards = this.forwards.filter((forward) => {
                return (
                    forward.sentTo.includes(this.searchForward.email) &&
                    (this.searchForward.agent !== ""
                        ? forward.fkUtenteAgente === this.searchForward.agent
                        : true) &&
                    (this.searchForward.gallery !== ""
                        ? forward.eventId === this.searchForward.gallery
                        : true)
                );
            });
        },

        clearFilter(filter) {
            switch (filter) {
                case "email":
                    this.searchForward.email = "";
                    this.filterCustom();
                    break;
                case "gallery":
                    this.searchForward.gallery = "";
                    this.filterCustom();
                    break;
                case "agent":
                    if (!this.isAgent) {
                        this.searchForward.agent = "";
                    }
                    this.filterCustom();
                    break;
                default:
                    this.searchForward.email = "";
                    this.searchForward.gallery = "";
                    if (!this.isAgent) {
                        this.searchForward.agent = "";
                    }
                    this.filterCustom();
                    break;
            }
        },

        getGalleryLabel(galleryId) {
            let gallery = this.galleries.filter((el) => el.id === galleryId);
            return gallery[0] ? gallery[0].title : "";
        },

        getAgentLabel(fkUtenteAgente) {
            if (!this.isAgent) {
                let agent = this.agents.filter(
                    (el) => el.fkUtenteAgente === fkUtenteAgente
                );
                return agent[0] ? agent[0].email : "";
            }
        }
    },
    computed: {
        paginationRows() {
            return this.filteredForwards.length;
        },

        isAgent() {
            var userDataBE = this.$store.getters.userDataBE;
            var isAgent = this.$store.getters.isAgent;
            console.debug("USERDATABE", userDataBE);
            return userDataBE && isAgent;
        }
    }
};
</script>

<style scoped>
.filters-labels {
    margin: 0;
    padding-left: 5px;
    padding-right: 5px;
    display: flex;
    align-items: center;
}
</style>
